export enum WebchatVideoCallRequestStatus {
	Pending = "Pending",
	Accepted = "Accepted",
	Declined = "Declined",
	Expired = "Expired",
	Cancelled = "Cancelled",
}

export interface WebchatVideoCallRequestCreatedResponse {
	requestId: string;
	expiresAt: string;
}

export interface WebchatVideoCallRequestChangedDto {
	conversationId: string;
	requestId: string;
	status: WebchatVideoCallRequestStatus;
	contactName?: string;
	targetAcsUserId?: string;
}

export interface WebchatVideoOutboundResponse {
	scenarioId: string;
	applicationInstanceId: string;
	targetAcsUserId: string;
	contactName?: string;
}
